import { useState, useContext, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { Link, useLocation } from 'react-router-dom';

import { MdHourglassTop, MdOutlineHourglassBottom, MdOutlineTimer, MdFormatListBulleted, MdReadMore, MdOutlineContentCopy, MdOutlineRemoveRedEye, MdEdit, MdDeleteOutline } from "react-icons/md";
import { IoEllipsisVertical, IoSchoolOutline } from "react-icons/io5";
import { BsFiletypeXls } from "react-icons/bs";
import { TbCoins } from "react-icons/tb";

import { AppContext } from "../../../Context";
import { Img } from "../../../components/Elements"; 
import Fetch, { Loader, DateToText, ClassToName } from "../../../inc/Fetch"; 
import GoogleShareToClassRoom from '../../../components/classRomm';

export default function Games({ v, onSave, setchecked, checked }) {
    
    const { t } = useTranslation();
    const location = useLocation();
    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;
    
    const [loader, setloader] = useState(false);
    const [copy, setcopy] = useState(false);
    const [del, setdel] = useState(false);
    const [menuOpen, setmenuOpen] = useState(false);

    function copyUrl(url) {

        navigator.clipboard.writeText(url);
        setcopy(true);
        setTimeout(() => {
            setcopy(false);
        }, 2000);
    }

    function deleteGame(id) {

        const conf = window.confirm(t("error",  { returnObjects: true })[2]);
        if (!conf) {
            return false;
        }

        setloader(true);

        Fetch("games/deleteGame", (d) => {

            if (d?.error) {
                setopen({ error:true, short: t("error",  { returnObjects: true })[d?.error] });
            } else {
                onSave(true);
            }
            
            setloader(false);
        }, { _id: id });
    }

    useEffect(() => {

        const closeFunc = (e) => {
            const selClose = e?.target.closest(".taskMenuBox");
            if (!selClose) {
                setmenuOpen(false)
            }
        }

        window.addEventListener("click", closeFunc);
        return () =>{
            window.removeEventListener("click", closeFunc);
        }
        

    }, []);

    const toggleSelect = (value) => {
        setchecked((prev) => prev.includes(value)
            ? prev.filter((item) => item !== value)
            : [...prev, value]
        );
    };

    if (del) {
        return false;
    }

    return (
        <div className='taskClassesBox'>
            <Img src={`img/130/${v?.game?.img}`} /> 
            
            <Link className='midFlex' to={userinfo?.userlevel >= 3 ? `/myGames/${v?._id}` : `/games/${v?._id}`}>
                <p>
                    <h3>{v?.title}</h3>
                    <h4>{v?.game?.subject?.name} - <DateToText time={v?.date} /></h4>
                </p>

                <ul className='taskInfoUl'>
                    <li style={{backgroundColor:"#ffb53a", color:"#000", padding:"2px 10px"}}>{t("class")} <ClassToName classes={v?.classes} /></li>
                    <li><MdHourglassTop />{v?.start_date ? <DateToText time={v?.start_date} />: t("no_value")}</li>
                    <li><MdOutlineHourglassBottom /> {v?.start_date ? <DateToText time={v?.end_date} />: t("no_value")}</li>
                    {v?.scores ? <li className='tag green'><TbCoins /> {t("game_score")} ({v?.scores})</li>: false}
                </ul>

                
            </Link>

            {userinfo?.userlevel >= 3 && <div className='gameVheckBox'>
                <input type='checkbox' checked={checked} onChange={() => toggleSelect(v?._id)} />
            </div>}

            {userinfo?.userlevel < 3 && 
                <div className={`taskAnswerStBox ${v?.answers?.score && v?.answers?.status && "bord"}`}>
                    {!v?.answers?.status && <span className='tag'>{t("task_student_status_0")}</span>}
                    {v?.answers?.status == 1 && <span className='tag orange'>{t("task_student_status_1")}</span>}
                    {v?.answers?.status == 2 && <span className='tag blue'>{t("task_student_status_2")}</span>}

                    {v?.answers?.score !== false && v?.answers?.status > 1 && <b>{v?.answers?.score}%</b>}
                </div>
            }

            
            <>
                {/* {userinfo?.userlevel >= 3 && <nav className='taskMenuBox'>
                    {copy && <div className='copyBox'>{t("tasks_copy_success")}</div>}
                    <a onClick={() => setmenuOpen(r => !r)} className='mainDotesMenu'><IoEllipsisVertical /></a>
                    
                    <ul className={menuOpen ? "open" : "closed"}>
                        <Link className='mLink' target='_blank' to={`/gamesStatsDownload/${v?._id}`} ><BsFiletypeXls /><b>{t("tasks_menu_7")}</b></Link>
                        <Link className='mLink' to={`/myGames/${v?._id}`}><MdReadMore /><b>{t("tasks_menu_1")}</b></Link>
                        <Link className='mLink' to={`/sendGame/${v?._id}`} state={{ previousLocation: location }}><MdEdit /><b>{t("tasks_menu_3")}</b></Link>
                        <a className='mLink'>
                            <GoogleShareToClassRoom
                                itemType="assignment"
                                url={`https://www.yallangany.com/games/${v?._id}`}
                                size={50}
                                title={v?.title}
                                theme="light"
                            />
                            
                            <b>{t("tasks_menu_4")}</b>
                        </a>

                        <a className='mLink'>
                            <div
                                className="teams-share-button"
                                data-href={`https://www.yallangany.com/games/${v?._id}`}
                                data-msg-text={v?.title}
                            >
                            </div><b>{t("tasks_menu_5")}</b>
                        </a>
                        <a onClick={() => copyUrl(`https://www.yallangany.com/games/${v?._id}`)} className='mLink'><MdOutlineContentCopy /><b>{t("tasks_menu_6")}</b></a>
                        <a onClick={() => deleteGame(v?._id)} className='mLink'><MdDeleteOutline /><b>{t("delete")}</b></a>
                    
                        
                    </ul>
                </nav>} */}
            </>
            
        </div>
    )
}
